<template>
  <RedesignTextLoading v-if="loading" class="w-64" />
  <h2 v-else>{{ title }}</h2>
</template>

<script setup lang="ts">
const confData = useConfdata()

const props = defineProps<{
  total: number
  loading?: boolean
}>()

const title = computed(() =>
  replacePlaceholders((confData.additionalBody as SearchPageBody).h2, {
    amount: props.total,
    destination: getDestinationName(confData.destination),
  }),
)
</script>
